var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41351 12L8 12",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13L20.9072 19.9072",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19.9072L20.9072 13",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3291 20.0513C9.38575 20.0513 7.44059 20.0513 6.05077 20.0513C4.9462 20.0513 4.05132 19.1571 4.05132 18.0525C4.05132 16.5647 4.05132 14.317 4.05131 11.5513C4.05131 9.25003 4.05132 7.32766 4.05133 5.99849C4.05135 4.89394 4.94541 4.00008 6.04996 4.00008C7.38675 4.00007 9.27303 4.00006 11.3291 4.00006",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpression);
export default __webpack_public_path__ + "static/media/expression.cbe08ec0c585a1cf99c3ea8cd1ea3577.svg";
export { ForwardRef as ReactComponent };